import * as React from 'react';
import { PropTypes } from 'prop-types';
import ChartistGraph from 'react-chartist';
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import { I18n } from 'react-redux-i18n-lite';

export class CustomDonutChart extends React.Component {
  static propTypes = {
    complete: PropTypes.number,
    success: PropTypes.number,
    pending: PropTypes.number,
    failed: PropTypes.number,
    initialized: PropTypes.number,
    uncompleted: PropTypes.number,
    label: PropTypes.string,
    textClassName: PropTypes.string,
    donutWidth: PropTypes.number,
    diameter: PropTypes.number,
    percentClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    hideText: PropTypes.any,
    icon: PropTypes.string,
    showTooltips: PropTypes.bool,
    completeClass: PropTypes.any
  };

  static defaultProps = {
    complete: 0,
    success: 0,
    pending: 0,
    failed: 0,
    initialized: 0,
    uncompleted: 0
  };

  renderPercentText = complete => {
    const { hideText, percentClassName } = this.props;
    if (!hideText) {
      return <span className={percentClassName ? percentClassName : 'donutchart-text'}>{parseInt(complete)}%</span>;
    }
  };

  renderIcon = () => {
    const { percentClassName, icon } = this.props;
    return <span className={percentClassName ? percentClassName : 'donutchart-text'}>{icon}</span>;
  };

  render() {
    let {
      diameter,
      complete,
      pending,
      success,
      failed,
      uncompleted,
      initialized,
      label,
      textClassName,
      donutWidth,
      containerClassName,
      showTooltips,
      completeClass
    } = this.props;

    const data = {
      series: [
        {
          value: complete ? complete.toFixed(2) : 0,
          className: completeClass || 'primary-donut',
          meta: I18n.t('gradebook.pie.completed') + '|#12abe3'
        },
        {
          value: success ? success.toFixed(2) : 0,
          className: 'green-donut',
          meta: I18n.t('gradebook.pie.success') + '|#58bf6e'
        },
        {
          value: failed ? failed.toFixed(2) : 0,
          className: 'red-donut',
          meta: I18n.t('gradebook.pie.failed') + '|#F05060'
        },
        {
          value: pending ? pending.toFixed(2) : 0,
          className: 'purple-donut',
          meta: I18n.t('gradebook.pie.pending') + '|#a17eb8'
        },
        {
          value: initialized ? initialized.toFixed(2) : 0,
          className: 'orange-donut',
          meta: I18n.t('gradebook.pie.initialized') + '|#ffae4d'
        },
        {
          value: uncompleted ? uncompleted.toFixed(2) : 0,
          className: 'gray-donut',
          meta: I18n.t('gradebook.pie.uncompleted') + '|#ddd'
        }
      ]
    };

    const options = {
      donut: true,
      total: 100,
      donutWidth: donutWidth ? donutWidth : 10,
      showLabel: false,
      height: diameter ? diameter : 110,
      width: diameter ? diameter : 110
    };

    if (showTooltips) {
      options.plugins = [
        ChartistTooltip({
          appendToBody: true,
          tooltipFnc: (meta, value) => {
            document.getElementsByClassName('chartist-tooltip')[0].style.borderColor = meta.split('|')[1];
            return meta.split('|')[0] + '<br>' + value + '%';
          }
        })
      ];
    }

    return (
      <div className={`main-donutchart ${containerClassName ? containerClassName : ''}`}>
        {this.props.icon ? this.renderIcon() : this.renderPercentText(complete + success + failed + pending)}
        {label && <span className={textClassName ? textClassName : 'donutchart-text'}>{label}</span>}
        <ChartistGraph data={data} type={'Pie'} options={options} />
      </div>
    );
  }
}

export default CustomDonutChart;
